import { IListRequest } from "@/types";

export class ListRequest implements IListRequest {
  public search = "";
  public page = 1;
  public per_page = 15;
  public sort_by = "";
  public sort_desc = false;
  [key: string]: unknown;

  public constructor(props?: IListRequest) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
